module.exports = __webpack_public_path__ + "img/album4-image-2.35ce8973.jpg";